import React from "react"
import { Flex, Text, Spinner } from "@radix-ui/themes"
import TurboLogoIcon from "../../TurboLogoIcon"

interface LoadingSpinnerProps {
  size?: "1" | "2" | "3"
  className?: string
  text?: string
  showLogo?: boolean
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "2",
  className = "",
  text,
  showLogo = false
}) => {
  return (
    <Flex direction="column" align="center" justify="center" className={className}>
      {showLogo ? (
        <div className="relative">
          <TurboLogoIcon size={size === "3" ? 48 : size === "2" ? 32 : 24} className="text-red-600 animate-pulse" />
          <div className="absolute inset-0 flex items-center justify-center">
            <Spinner size={size === "3" ? "2" : size === "2" ? "1" : "1"} />
          </div>
        </div>
      ) : (
        <Spinner size={size} />
      )}
      {text && (
        <Text size="2" color="gray" mt="4">
          {text}
        </Text>
      )}
    </Flex>
  )
}

export default LoadingSpinner 